import './ShipmentList.css'

import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import { axiosWithPostUrlEncoded as axios } from 'config/axios.js'
import format from 'date-fns/format'
import { getShipmentList } from 'api/ispyb.js'
import parse from 'date-fns/parse'
import { useSelector } from 'react-redux'

const ShipmentList = () => {
  const user = useSelector(state => state.user)
  const proposals = useSelector(state => state.proposalInfo.data.map(d => d.proposal).flat())
  const proposalName = proposals[0].code + proposals[0].number

  const [shipments, setShipments] = useState([])

  useEffect(() => {
    axios.get(getShipmentList(user, proposalName)).then(({ data: shipmentData }) => setShipments(shipmentData))
  }, [proposalName, user])

  const shipmentCountsById = shipments.reduce((acc, shipment) => {
    const currentCounts = acc[shipment.Shipping_shippingId] || { parcelCount: 0, sampleCount: 0 }
    return {
      ...acc,
      [shipment.Shipping_shippingId]: {
        parcelCount: currentCounts.parcelCount + 1,
        sampleCount: currentCounts.sampleCount + shipment.sampleCount,
        shipment,
      },
    }
  }, {})

  const orderedShipments = Object.keys(shipmentCountsById)
    .map(id => parseInt(id))
    .sort((a, b) => b - a)
    .map(id => shipmentCountsById[id])

  return (
    <div>
      {orderedShipments.map(({ shipment, parcelCount, sampleCount }) => (
        <Table className="shipmentlisttable" border="3" key={shipment.Shipping_shippingId}>
          <tbody>
            <tr>
              <td>
                <Link to={'/prepare/mxshipments/' + shipment.Shipping_shippingId}>
                  {shipment.Shipping_shippingName}
                </Link>
              </td>
            </tr>
            <tr>
              <td>
                {format(parse(shipment.Shipping_creationDate, 'MMM d, yyyy h:mm:ss aaa', new Date()), 'dd-MM-yyyy')}
              </td>
            </tr>
            <tr>
              <td>
                {parcelCount} parcels ({sampleCount} samples)
              </td>
            </tr>
            <tr>
              <td>{shipment.Shipping_shippingStatus}</td>
            </tr>
          </tbody>
        </Table>
      ))}
    </div>
  )
}

export default ShipmentList
